// extracted by mini-css-extract-plugin
module.exports = {"icon":"styles_icon__12eQH","xlg":"styles_xlg__1nvto","lg":"styles_lg__1B6uC","md":"styles_md__31aXg","sm":"styles_sm__1Cy3n","xs":"styles_xs__3dfF_"};